import { useEffect, useState } from 'react';
import api from '../../services/api';
import axios from 'axios';
import Rodape from '../../components/Rodape';
import Topo from '../../components/Topo';
import {Animated} from "react-animated-css";
import sistema from '../../config';

function LoginPage(props){
  return (
  <section id="login">
    <div className="col-md-4 col-md-offset-4">
      <div className="login-panel panel panel-default">
          <div className="panel-heading">
              <h3 className="panel-title">BEM VINDO AO SISTEMA {sistema.nome}</h3>
              <p>digite seu e-mail para recuperar sua senha</p>
          </div>
          
          <div className="panel-body">
              <form method="POST" onSubmit={props.Submit}>
                  <fieldset>
                      <div className="form-group">
                          <input className="form-control" placeholder="E-mail" value={props.usuario} onChange={(e)=> {props.setUsuario(e.target.value)}} name="email" type="text" autoFocus={true}/>
                      </div>
                      
                          {props.msg.length > 0  && (<center>{props.msg}</center>)}
                          <button className="btn btn-lg btn-success" style={{marginTop: '10px'}}>RECUPERAR SENHA</button>
                          <div style={{display: 'flex', justifyContent: 'space-between'}}>
                          <span className="inip"><a href="../../Logue-se">Logue-se</a></span>
                          <span className="inip"><a href="../../Cadastre-se">Cadastre-se</a></span>
                          </div>
                          {/* <span className="inip">IP de acesso: {props.ip.length ? props.ip : 'Carregando...'}</span> */}
                          </fieldset>
                  </form>
              </div>
          </div>
      </div>
  </section>	
  );
}

function Login() {

  const [ip, setIp] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [msg, setMsg] = useState('');
 
  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/');
    setIp(res.data.IPv4);
  };

  const Submit = async (e) => {
    e.preventDefault(0);
    setMsg('Aguarde...');
    
    try{
      var res = await api.post("/recsenha",{email: usuario});
    }catch(e){
      var res = '';
      setMsg('Ocorreu um erro interno...');
    }

    if(res.data.msg){
      setMsg(res.data.msg);
    }else{
      setMsg('Ocorreu um erro interno...');
    }

  };

  useEffect(()=>{
    
    getData();
  }, []);

  return (
    <Animated animationIn="bounceInLeft" animationOut="fadeOut" isVisible={true}>
    <div className="main-content" style={{marginLeft: '0'}}>
      <Topo/>
      <LoginPage Submit={Submit} usuario={usuario} setUsuario={setUsuario} msg={msg} senha={senha} setSenha={setSenha} ip={ip}/>
    </div>
    </Animated>
  );
}

export default Login;
